import { Helmet } from "react-helmet-async"
import { WhatsAppFlowsList } from "../../../../../../Integrations"
import { useOutletContext } from "react-router"

export default function WhatsAppIntegrationFlowsPage() {
	const context = useOutletContext<{
		integrationId: number
		appId: number
	}>()

	return (
		<>
			<Helmet>
				<title>Flows | WA</title>
			</Helmet>
			<WhatsAppFlowsList
				integratedAppId={context.appId}
				integrationId={context.integrationId}
			/>
		</>
	)
}
